import { z } from 'zod';

import {
  OptionalBaseEncounterParamsFormFields,
  OptionalBaseEncounterParamsSchema,
} from './Encounters';
import {
  OptionalBasePatientOrderParamsFormFields,
  OptionalBasePatientOrderParamsSchema,
} from './PatientOrders';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { OptionalStringSchema, PatientSexSchema, RequiredStringSchema } from '../common';

export const PatientJobParamsSchema = OptionalBaseEncounterParamsSchema.merge(
  OptionalBasePatientOrderParamsSchema
).merge(
  z.object({
    ehrInformationId: OptionalStringSchema,
    patientEhrId: RequiredStringSchema,
    patientFhirId: OptionalStringSchema,
    patientFirstName: RequiredStringSchema,
    patientLastName: RequiredStringSchema,
    patientDateOfBirth: RequiredStringSchema,
    patientPhoneNumber: OptionalStringSchema,
    patientSex: PatientSexSchema,
    existingPatientMailingAddress: OptionalStringSchema,
    athenaIdxMrn: OptionalStringSchema,
  })
);

export function PatientJobParamsFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.payload.patientFirstName"
        label="Patient First Name"
        helperText="Enter the reference to the Patient First Name. e.g. `{{patient.data.patientFirstName}}`"
        placeholder="e.g. {{patient.data.patientFirstName}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientLastName"
        label="Patient Last Name"
        helperText="Enter the reference to the Patient Last Name. e.g. `{{patient.data.patientLastName}}`"
        placeholder="e.g. {{patient.data.patientLastName}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientDateOfBirth"
        label="Patient Date of Birth"
        helperText="Enter the reference to the Patient Date of Birth. e.g. `{{patient.data.patientDateOfBirth}}`"
        placeholder="e.g. {{patient.data.patientDateOfBirth}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientSex"
        label="Patient Sex"
        helperText="Enter the reference to the Patient Sex. e.g. `{{patient.data.patientSex}}`"
        placeholder="e.g. {{patient.data.patientSex}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientEhrId"
        label="MRN"
        helperText="Enter the reference to the Patient Ehr Id. e.g. `{{patient.data.patientEhrId}}`"
        placeholder="e.g. {{patient.data.patientEhrId}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.ehrInformationId"
        label="Ehr Information Id"
        helperText="Enter the reference to the Ehr Information Id. e.g. `{{patient.data.ehrInformationId}}`"
        placeholder="e.g. {{patient.data.ehrInformationId}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientFhirId"
        label="Patient Fhir Id"
        helperText="Enter the reference to the Patient Fhir Id. e.g. `{{patient.data.patientFhirId}}`"
        placeholder="e.g. {{patient.data.patientFhirId}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientPhoneNumber"
        label="Patient Phone Number"
        helperText="Enter the reference to the Patient Phone Number. e.g. `{{patient.data.patientPhoneNumber}}`"
        placeholder="e.g. {{patient.data.patientPhoneNumber}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.existingPatientMailingAddress"
        label="Existing Patient Mailing Address"
        helperText="Enter the reference to the Existing Patient Mailing Addres. e.g. `{{patient.data.existingPatientMailingAddress}}`"
        placeholder="e.g. {{patient.data.existingPatientMailingAddress}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.athenaIdxMrn"
        label="Athena Idx Mrn"
        helperText="Enter the reference to the Athena Idx Mrn. e.g. `{{patient.data.athenaIdxMrn}}`"
        placeholder="e.g. {{patient.data.athenaIdxMrn}}"
      />
      <OptionalBaseEncounterParamsFormFields />
      <OptionalBasePatientOrderParamsFormFields />
    </>
  );
}
